export const state = {
  layout: 'side',
  showTypes: false,
  showIdx: false,
  theme: 'dark',
  lastParsed: null,
  nodeId: 0,
  debounceTimer: null,
};
